import type {Result, UseCase} from 'framework';
import type {LineIngredientCandidate} from '../../domain/line-ingredient-candidate';
import type {SavedMealError} from '../../domain/errors';
import type {
  LookupLineIngredientByBarcodeInput,
  SavedMealRepository,
} from '../ports/saved-meal.repository';

/** Resolves a scanned barcode to at most one candidate; a miss is an empty list. */
export class LookupLineIngredientByBarcode implements UseCase<
  [LookupLineIngredientByBarcodeInput],
  readonly LineIngredientCandidate[]
> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(
    input: LookupLineIngredientByBarcodeInput,
  ): Promise<Result<readonly LineIngredientCandidate[], SavedMealError>> {
    return this.repository.lookupLineIngredientByBarcode(input);
  }
}
